import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';
import { createIONum } from '@/pages/settings/redux/slice';
//  createCategory
import { Col, Form, Input, Row, message } from 'antd';

import React from 'react';
import { useDispatch } from 'react-redux';

const AddModal = ({
  onCancel,
  isModalVisible,
  setIsModalOpen,
  handlegetIONum
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const onFinish = (values) => {
    dispatch(createIONum(values)).then((response) => {
      if (response.payload.success) {
        message.success(response.payload.message);
        setIsModalOpen(false);
        handlegetIONum();
      } else {
        message.error(response.payload.message);
      }
    });
  };

  return (
    <CustomModal
      footer={
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          className="ant-form ant-form-vertical"
        >
          <Row>
            <Col className="text-left" span={12}>
              <CustomButton onClick={onCancel}>Cancel</CustomButton>{' '}
            </Col>
            <Col className="text-right" span={12}>
              <CustomButton
                /* onClick={onOk} */ type="primary"
                htmlType="submit"
              >
                Add
              </CustomButton>
            </Col>
          </Row>
        </Form>
      }
      onCancel={onCancel}
      visible={isModalVisible}
      title="Add I/O No"
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        className="ant-form ant-form-vertical"
      >
        <Row gutter={24}>
          <Col span={12}>
            <FormItem
              label={'I/O No'}
              name="number"
              // className={`${styles.astrick}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter I/O No'
                }
              ]}
            >
              <Input placeholder="Enter I/O No" />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label={'I/O Amount'}
              name="amount"
              // className={`${styles.astrick}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter I/O Amount'
                },
                {
                  pattern: /^\d*\.?\d*$/,
                  message: 'Please enter a valid numeric value'
                }
              ]}
            >
              <Input placeholder="Enter I/O Amount" />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </CustomModal>
  );
};

export default AddModal;
